import { makeStyles } from '@lifeomic/chroma-react/styles';

/**
 * @description Styles shared across all variant types for the variant
 * details modal.
 */
export const useSharedDetailsStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridGap: theme.spacing(4),
    gridTemplateColumns: 'repeat(2, 1fr)',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  paper: {
    display: 'grid',
    gridGap: `0 ${theme.spacing(4)}`,
    gridTemplateColumns: 'repeat(2, 1fr)',
    padding: theme.spacing(2.125, 4, 3.25, 2),
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
    '& + $paper': {
      marginTop: theme.spacing(4),
    },
    '& dl': {
      alignContent: 'flex-start',
      display: 'grid',
      fontSize: theme.pxToRem(14),
      gridGap: theme.spacing(1),
      gridTemplateColumns: 'repeat(2, 1fr)',
      margin: theme.spacing(1, 0, 0),
      '& + dl': {
        [theme.breakpoints.down('sm')]: {
          borderTop: `solid 1px ${theme.palette.divider}`,
          paddingTop: theme.spacing(1),
          marginLeft: theme.spacing(3.5),
        },
      },
      '&:first-of-type': {
        marginLeft: theme.spacing(3.5),
      },
    },
    '& dt, & dd': {
      lineHeight: 1.25,
    },
    '& dt': {
      fontWeight: 'normal',
      whiteSpace: 'nowrap',
    },
    '& dd': {
      color: theme.palette.text.secondary,
      // Need !important here to override Bootstrap reboot
      marginBottom: '0 !important',
      wordBreak: 'break-word',
      '&:empty': {
        '&:after': {
          content: "'—'",
          opacity: 0.35,
        },
      },
    },
    '&$oneCol': {
      gridTemplateColumns: '1fr',
      gridGap: 0,
      '& dl': {
        gridTemplateColumns: '1fr 3fr',
      },
    },
  },
  oneCol: {},
  subhead: {
    alignItems: 'center',
    gridColumn: 'span 2',
    lineHeight: 1.25,
    margin: theme.spacing(0, 0, 0.5),
  },
  icon: {
    color: theme.palette.text.hint,
    margin: theme.spacing(0, 1, 0, -0.25),
    height: theme.pxToRem(22),
    width: theme.pxToRem(22),
  },
  divider: {
    gridColumn: 'span 2',
    margin: 0,
  },
}));
